<template>
  <v-combobox
    :items="items"
    :search-input.sync="searchInput"
    outlined
    dense
    hide-details
    :append-icon="null"
    append-outer-icon="mdi-magnify"
    @blur="blurHandler"
    @click:append-outer="searchHandler"
    @input="selectHandler"
    @keydown.enter="searchHandler"
    :label="label"
    :placeholder="placeholder"
    :value="initialSearchText"
    style="z-index: 15;"
  >
    <template v-slot:item="data">
      <v-chip
        :key="JSON.stringify(data.item)"
        v-bind="data.attrs"
        :color="chipColor(data.item.type)"
        dark
        :input-value="data.selected"
        :disabled="data.disabled"
        @click:close="data.parent.selectItem(data.item)"
      >
        <v-icon class="mr-2" small>{{ chipIcon(data.item.type) }}</v-icon>
        {{ data.item.text }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    initialSearchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchInput: '',
      searchText: ''
    }
  },
  watch: {
    searchInput(newVal) {
      if (!newVal || newVal == '') {
        this.$emit('clearitems')
      } else if (this.items.length == 0) {
        this.$emit('fillitems')
      }
    }
  },

  methods: {
    chipColor(type) {
      if (type == 'tag' || type == 'journey') {
        return 'blue'
      }
      if (type == 'location') {
        return 'green'
      }
      return 'gray'
    },
    chipIcon(type) {
      if (type == 'tag') {
        return 'mdi-tag'
      }
      if (type == 'location') {
        return 'mdi-map-marker'
      }
      if (type == 'journey') {
        return 'mdi-book-open-variant'
      }
      return ''
    },
    blurHandler() {
      this.$emit('clearitems')
    },
    selectHandler(val) {
      console.log('SELECTED', val)
      if (val.text) {
        // почему-то @input срабатывает, когда кликаешь рядом со списком тэгов и локейшенов, пытаясь ничего не выбрать
        // в этом случае в качестве val передаетсяя строка
        // нам ничего делать не надо в этом случае, поэтому мы шлем 'selected' эвент только когда нам в качестве val пришел объект
        this.$emit('selected', val)
      }
    },
    searchHandler() {
      this.$emit('search', this.searchInput)
    }
  }
}
</script>

<style></style>
